import EmailIcon from "@mui/icons-material/Email";
import FacebookIcon from "@mui/icons-material/Facebook";
import ShareIcon from "@mui/icons-material/Share";
import TwitterIcon from "@mui/icons-material/Twitter";
import { Box } from "@mui/material";
import { theme } from "src/theme/theme";
import SocialShareButton from "./SocialShareButton";

interface SocialShareRowProps {
  url: string;
  text: string | undefined;
  hashtags: string;
}

const SocialShareRow = ({ url, text, hashtags }: SocialShareRowProps) => {
  const encodedUrl = encodeURIComponent(url);

  const twitterUrl = `https://twitter.com/intent/tweet?url=${encodedUrl}&text=${text}${hashtags ? `&hashtags=${hashtags}` : ""}`;
  const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`;
  const emailUrl = `mailto:?subject=Hey come join me on trainwell&body=${text}%0A%0A${encodedUrl}`;

  const handleShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: document.title,
          text: text,
          url: url,
        });
      } catch (error) {
        console.log("Sharing failed", error);
        // Handle error, e.g., display a fallback link or message
      }
    } else {
      // Fallback for browsers that don't support the Web Share API
      alert(
        "Web Share API is not supported in your browser, we can't share directly",
      );
    }
  };

  return (
    <Box
      style={{
        display: "flex",
        flexDirection: "row",
        gap: theme.spacing(1),
        marginTop: theme.spacing(2),
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <SocialShareButton
        title="Share on Twitter"
        url={twitterUrl}
        icon={<TwitterIcon />}
      />

      <SocialShareButton
        title="Share on Facebook"
        url={facebookUrl}
        icon={<FacebookIcon />}
      />

      <SocialShareButton
        title="Share via Email"
        url={emailUrl}
        icon={<EmailIcon />}
      />

      <SocialShareButton
        title="Share"
        url={url}
        icon={<ShareIcon />}
        onClick={handleShare}
      />
    </Box>
  );
};

export default SocialShareRow;
